import { render, staticRenderFns } from "./canteenStatement.vue?vue&type=template&id=44bcbfd4&scoped=true&"
import script from "./canteenStatement.vue?vue&type=script&lang=js&"
export * from "./canteenStatement.vue?vue&type=script&lang=js&"
import style0 from "./canteenStatement.vue?vue&type=style&index=0&id=44bcbfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bcbfd4",
  null
  
)

export default component.exports